// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3a6l8","toggle":"styles_toggle__6Bley","preview":"styles_preview__3T1cm"};